<template>
  <!-- Filter options -->
  <div class="offer-filter">
    <v-modal :modalName="modalName" class="offer-filter__container">
      <template slot="header">
        <div class="offer-filter__container__header">
          <span class="offer-filter__container__header--title">Find offers</span>
          <v-btn
            text
            fab
            large
            @click="toggleFilterModal()"
            class="offer-filter__container__header--close"
          >
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>
      <template slot="body">
        <div class="offer-filter__container__body">
          <v-tabs v-model="tab" grow>
            <v-tab v-for="tab in tabItems" :key="tab">{{tab}}</v-tab>
            <v-tab-item>
              <!-- Location -->
            </v-tab-item>
            <v-tab-item class="offer-filter__container__body__tab">
              <!-- Added -->
              <v-subheader>Added</v-subheader>
              <v-select
                outlined
                dense
                v-model="duration.added"
                :items="duration.added"
                label="Added"
                class="offer-filter__container__body__select"
              ></v-select>
              <v-divider />

              <!-- Start time -->
              <v-subheader class="text pa-0">Offer begins</v-subheader>
              <div class="offer-filter__container__body__start">
                <v-select
                  outlined
                  dense
                  v-model="duration.start.hour"
                  :items="duration.start.hour"
                  label="Hour"
                  class="offer-filter__container__body__select"
                ></v-select>
                <v-select
                  outlined
                  dense
                  v-model="duration.start.minute"
                  :items="duration.start.minute"
                  label="Minute"
                  class="offer-filter__container__body__select"
                ></v-select>
              </div>
              <v-divider />

              <!-- End time -->
              <v-subheader class="text pa-0">Offer ends</v-subheader>
              <div class="offer-filter__container__body__end">
                <v-select
                  outlined
                  dense
                  v-model="duration.end.hour"
                  :items="duration.end.hour"
                  label="Hour"
                  class="offer-filter__container__body__select"
                ></v-select>
                <v-select
                  outlined
                  dense
                  v-model="duration.end.minute"
                  :items="duration.end.minute"
                  label="Minute"
                  class="offer-filter__container__body__select"
                ></v-select>
              </div>
            </v-tab-item>
            <v-tab-item class="offer-filter__container__body__advanced">
              <!-- TRIBE -->
              <v-subheader class="offer-filter__container__advanced--tribe-title">Tribe</v-subheader>
              <v-combobox
                :items="tribes"
                item-value="name"
                item-text="name"
                placeholder="E.g. LGBT+"
                return-object
                v-model="tribe"
                flat
                outlined
                class="offer-filter__container__body__combo"
              >
                <template v-slot:item="data">
                  <v-list-item-content>{{ data.item.name }}</v-list-item-content>
                </template>
              </v-combobox>
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
      <template slot="footer">
        <div class="offer-filter__container__footer">
          <v-btn text fab @click="saveFilter" class="check">
            <font-awesome-icon icon="check" />
          </v-btn>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import VModal from "@/components/VModal";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    VModal
  },

  props: {
    tribes: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      modalName: "filter-modal",

      tab: null,
      tabItems: ["Location", "Duration", "Advanced"],
      duration: {
        added: "",
        start: {
          hour: "",
          minute: ""
        },

        end: {
          hour: "",
          minute: ""
        }
      }
    };
  },

  methods: {
    ...mapActions({ toggleFilterModal: "ui/filterModalState" })
  },

  computed: {
    ...mapState({
      ui: state => state.ui
    }),

    showFilterModal() {
      return this.ui.toggleFilterModal;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "@/styles/variables.sass"
@import "@/styles/mixins.sass"
@import "@/styles/base.sass"

.offer-filter
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  overflow: hidden
  backdrop-filter: blur(4px)
  background: rgba($c-black, .3)
  z-index: 20

  &__container
    width: 600px
    border-radius: 15px
    padding: 20px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)
    transform: scale(.7)

    &__header
      &--title
        position: relative
        left: 225px

      &--close
        position: relative
        top: -30px
        left: 410px

    &__body
      width: 100%
      display: flex
      flex-flow: row
      justify-content: flex-start

      &__select
        transition: all .3s
        border-radius: 20px
        transform: scale(.8)

    &__location
      padding: 15px

    &__duration
      padding: 30px

      &--added-title
        padding: 0
        @include for-size(phone-only)
            width: 30%

      &--added-select
        width: 30%
        height: 50px
        border-radius: 25px
        padding: 0
        margin: 0

        @include for-size(phone-only)
            width: 100%

        @include for-size(tablet-portrait-up)
            width: 100%

        &__start, &__end
          display: flex
          flex-direction: row

          &--select
              border-radius: 25px
              margin: 20px
          
              @include for-size(phone-only)
                  width: 40%
                  margin: 5px 0 5px 15px

    &__footer
      display: flex
      justify-content: center
      height: 100px
      padding: 30px
</style>